import React from 'react';
import { FormattedMessage } from 'react-intl';
import { AppState } from 'src/AppState';
import {
	ControlConfiguration,
	EasyClaimDocumentType,
} from 'src/easyclaim.api.client.typescript/src';
import CustomerConfigurationContext from 'src/easyclaim.app.contexts/CustomerConfigurationContextCore';

import { DetailsContainer } from '../easyclaim.app.components/index';
import { ImageSelectionService } from '../easyclaim.app.services';
import { Image } from '../easyclaim.app.services/ImageSelectionService';

import { OdometerControlInputType } from './Controls/OdometerAndMileageControl';
import OdometerAndMileageControl from './Controls/OdometerAndMileageControl';
import { OverallDashboardControl } from './Controls/OverallDashboardControl';
import { VinControl } from './Controls/VinControl';
import { WindshieldControl } from './Controls/WindshieldControl';
import { ScreenComponent } from './ScreenComponent';

export function isAnyOfImagesLoading(images: Image[]): boolean {
	const result = !!images && images.length > 0 && images.some(ImageSelectionService.isImageLoading);

	return result;
}

export interface FourAdditionalPicturesProps extends AppState {
	odometerControlInputType: OdometerControlInputType;
	screenConfiguration: ControlConfiguration[];
	enableMotorbikesSupport: boolean;
}

export class FourAdditionalPictures extends ScreenComponent<FourAdditionalPicturesProps, {}> {
	get mileage() {
		return this.props.easyClaimCase?.vehicle?.userProvidedMileage;
	}

	public render() {
		return (
			<CustomerConfigurationContext.Consumer>
				{({ configuration }) => {
					const isProgressBarEnabled = configuration?.isImageUploadProgressBarVisible;

					return (
						<div className="main-container">
							{!!isProgressBarEnabled || (
								<h2 className="four-additional-pictures-title">
									<FormattedMessage id="fourAdditionalPictures.title" />
								</h2>
							)}
							<DetailsContainer className="four-additional-pictures-container">
								{this.props.screenConfiguration.map((controlConfiguration) => {
									switch (controlConfiguration.documentType) {
										case EasyClaimDocumentType.WindshieldPicture:
											return (
												<WindshieldControl
													key={controlConfiguration.documentType}
													{...this.props}
												/>
											);
										case EasyClaimDocumentType.OverallDashboardPicture:
											return (
												<OverallDashboardControl
													key={controlConfiguration.documentType}
													{...this.props}
												/>
											);
										case EasyClaimDocumentType.VinPicture:
											return <VinControl key={controlConfiguration.documentType} {...this.props} />;
										case EasyClaimDocumentType.DashboardPicture:
											return (
												<OdometerAndMileageControl
													key={controlConfiguration.documentType}
													appState={this.props}
													screen={this.props.screen!}
													odometerTextInputType={this.props.odometerControlInputType}
													enableMotorbikesSupport={this.props.enableMotorbikesSupport}
												/>
											);
										default:
											return null;
									}
								})}
							</DetailsContainer>
						</div>
					);
				}}
			</CustomerConfigurationContext.Consumer>
		);
	}
}
